import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";

const ADMIN_ROLES = ["super_admin", "admin"];

export default function RequireAdmin({ children }) {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="min-h-[calc(100vh-4rem)] grid place-items-center" data-testid="admin-auth-checking">
        <Loader2 className="w-7 h-7 text-indigo-600 animate-spin" />
      </div>
    );
  }
  if (!user || !ADMIN_ROLES.includes(user.role)) return <AdminLogin />;
  return children;
}
